import { render, staticRenderFns } from "./InterviewsInfo.vue?vue&type=template&id=effdbb28&scoped=true&"
import script from "./InterviewsInfo.vue?vue&type=script&lang=js&"
export * from "./InterviewsInfo.vue?vue&type=script&lang=js&"
import style0 from "./InterviewsInfo.vue?vue&type=style&index=0&id=effdbb28&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effdbb28",
  null
  
)

export default component.exports